import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-system",
  "use": "icon-system-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-system\"><defs><style type=\"text/css\"></style></defs><path d=\"M747.8 323.9L474.2 597.4l-24.9 24.9c-13.7 13.7-36 13.7-49.7 0l-24.9-24.9-99.5-99.5c-13.7-13.7-13.7-36 0-49.7 13.7-13.7 36-13.7 49.7 0l99.5 99.5L698 274.1c13.7-13.7 36-13.7 49.7 0 13.8 13.8 13.8 36 0.1 49.8z m155.8 492.7c30.9 0 56-25.1 56-56V154.1c0-30.9-25.1-56-56-56H120.2c-30.9 0-56 25.1-56 56v606.6c0 30.9 25.1 56 56 56H344v56c0 30.9 25.1 56 56 56h223.8c30.9 0 56-25.1 56-56v-56h223.8z m-7.4-648.2V747H128V168.4h768.2z\" p-id=\"16381\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/system.svg
// module id = fkAr
// module chunks = 34